<div *ngIf="selectedCompany?.socialSites?.length > 0 || selectedCompany?.blurb?.length > 0" [style.background]="footerColor" class="gs-toast fixed-bottom bg-gray-dark-extra text-white">
  <span *ngIf="selectedCompany?.blurb" class="mr-3" [innerHtml]="selectedCompany?.blurb | safeHtml"></span>
  <a class="btn btn-trans" *ngFor="let site of selectedCompany?.socialSites; index as i" [href]="site.url" target="_blank" [title]="site.name" class="btn btn-trans">
    <i [innerHtml]="site.image | safeHtml" style="fill:#fff;"></i>
  </a>
</div>